(function () {
	const root = document.querySelector('[data-faq-filter-root]');
	if (!root) return;

	// Search input lives either inside the accordion section (default) or in the
	// hero. Query both so the input is found wherever the page placed it.
	const input = root.querySelector('[data-faq-filter-input]')
		|| document.querySelector('[data-faq-filter-input]');
	const items = root.querySelectorAll('.accordion-item');
	const empty = root.querySelector('.faq-section__empty');
	if (!input || !items.length) return;

	// Optional UI: "Search results for: X — N results found" banner and any
	// secondary FAQ sections that should hide while a search is active.
	const banner = document.querySelector('[data-faq-search-banner]');
	const bannerTerm = document.querySelector('[data-faq-search-term]');
	const bannerCount = document.querySelector('[data-faq-search-count]');
	const otherRoots = Array.from(document.querySelectorAll('[data-faq-filter-root]')).slice(1);

	// Match the resource-search pattern: filter on Enter only, not on every keystroke.
	input.addEventListener('keydown', function (e) {
		if (e.key === 'Enter') {
			e.preventDefault();
			filter();
		}
	});

	// Convenience: clearing the field instantly (X button or full backspace) restores
	// the default 3 without needing a separate Enter press.
	input.addEventListener('input', function () {
		if (input.value === '') filter();
	});

	function filter() {
		const q = input.value.trim().toLowerCase();
		const isSearching = q !== '';
		let visible = 0;

		items.forEach(function (item) {
			const isDefault = item.getAttribute('data-faq-default') === '1';
			let show;

			if (isSearching) {
				const haystack = (item.textContent || '').toLowerCase();
				show = haystack.indexOf(q) !== -1;
			} else {
				show = isDefault;
			}

			item.hidden = !show;
			if (show) visible++;

			const btn = item.querySelector('.accordion-button');
			const panel = item.querySelector('.accordion-collapse');
			if (!btn || !panel) return;

			if (isSearching && show) {
				// Auto-expand every match while searching.
				btn.classList.remove('collapsed');
				btn.setAttribute('aria-expanded', 'true');
				panel.classList.add('show');
			}
		});

		// When restoring defaults, open the first visible item and collapse the rest.
		if (!isSearching) {
			let foundFirst = false;
			items.forEach(function (item) {
				if (item.hidden) return;
				const btn = item.querySelector('.accordion-button');
				const panel = item.querySelector('.accordion-collapse');
				if (!btn || !panel) return;
				if (!foundFirst) {
					btn.classList.remove('collapsed');
					btn.setAttribute('aria-expanded', 'true');
					panel.classList.add('show');
					foundFirst = true;
				} else {
					btn.classList.add('collapsed');
					btn.setAttribute('aria-expanded', 'false');
					panel.classList.remove('show');
				}
			});
		}

		if (empty) empty.hidden = visible !== 0;

		// Banner + sibling-section visibility track the search state.
		if (banner) banner.hidden = !isSearching;
		if (isSearching) {
			if (bannerTerm) bannerTerm.textContent = input.value.trim();
			if (bannerCount) bannerCount.textContent = visible;
		}
		otherRoots.forEach(function (r) { r.hidden = isSearching; });
	}
})();
